<template>
    <div>
      <el-tabs v-model="qdtab" style="margin-left: 40px; margin-right: 40px;">
        <el-tab-pane label="常规" name="normal">
        </el-tab-pane>
        <el-tab-pane label="退货" name="refuse">
          <el-row class="querypanel">
            <el-col :span="24">
              <div class="leftpanel">
                <div>退货入库（测试）:</div>
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="记录号">
                    <el-input v-model="recno"></el-input>
                  </el-form-item>
                  <el-form-item label="ISBN">
                    <el-input v-model="isbn"></el-input>
                  </el-form-item>
                  <el-form-item label="图书名称">
                    <el-input v-model="gname" placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item label="图书编码" >
                    <el-input v-model="gcode" placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item label="图书定价" >
                    <el-input v-model="bprice" placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item label="状况" >
                    <el-radio-group v-model="bstatus">
                      <el-radio :label="3">好书</el-radio>
                      <el-radio :label="6">残书</el-radio>
                      <el-radio :label="9">破书</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="货位" >
                    <el-input v-model="gpos" placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item>
                    </el-form-item>
                </el-form>
              </div>
            </el-col>
            <el-col :span="24">
              <el-table
                id="thtable"
                :data="thdata"
                style="width: 100%">
                <el-table-column
                  prop="recno"
                  label="记录号"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="isbn"
                  label="ISBN"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="gname"
                  label="图书名称">
                </el-table-column>
                <el-table-column
                  prop="gcode"
                  label="图书编码">
                </el-table-column>
                <el-table-column
                  prop="bprice"
                  label="图书定价">
                </el-table-column>
                <el-table-column
                  prop="hs"
                  label="好书">
                </el-table-column>
                <el-table-column
                  prop="cs"
                  label="残书">
                </el-table-column>
                <el-table-column
                  prop="ps"
                  label="破书">
                </el-table-column>
                <el-table-column
                  prop="gpos"
                  label="货位">
                </el-table-column>
                <el-table-column
                  label="操作"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除记录" placement="top-start">
                      <i class="fa fa-trash-o fa-lg curpointer" v-on:click="delrec(scope.$index, thdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-divider></el-divider>
              <el-button @click="adddata">添加数据</el-button>
              <el-button @click="makedata" style="margin-top: 40px;">生成Excel</el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'
  export default {
    name: 'ExcelMods',
    data () {
      return {
        qdtab: 'normal',
        recno: '8',
        isbn: '978-7-5360-8988-4',
        gname:'广州沧桑录（1911—1949）',
        gcode: 'G000000116',
        bprice: '98',
        bstatus: 6,
        gpos: '辛峰仓/A050',
        thdata: []
      }
    },
    methods: {
      adddata () {
        var hstmp,cstmp,pstmp
        if (this.bstatus === 3) {
          hstmp = 'Y'
          cstmp = 'N'
          pstmp = 'N'
        }
        if (this.bstatus === 6) {
          hstmp = 'N'
          cstmp = 'Y'
          pstmp = 'N'
        }
        if (this.bstatus === 9) {
          hstmp = 'N'
          cstmp = 'N'
          pstmp = 'Y'
        }
        var data = {
          recno: this.recno,
          isbn: this.isbn,
          gname: this.gname,
          gcode: this.gcode,
          bprice: this.bprice,
          hs: hstmp,
          cs: cstmp,
          ps: pstmp,
          gpos: this.gpos
        }
        this.thdata.push(data)
      },
      delrec (index, data) {
        data.splice(index, 1)
      },
      makedata () {
        // 表名
        var wb = XLSX.utils.table_to_book(document.querySelector('#thtable'))
        /* get binary string as output */
        var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'thtable.xlsx')
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
        return wbout
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/workspace/ExcelMods.vue